import Vue from 'vue';
import Router from 'vue-router';
import api from '../api/api';
import config from '../api/params.config';
import AES from '../assets/js/encrypt/AES';
const Login = () => import('./../views/login-view/Login');

Vue.use(Router);

const router = new Router({
  // mode: 'history',
  routes: [
    {
      path: '/',
      name: 'login',
      component: Login,
      meta: {
        title: '登录',
      },
    },
    {
      path: '/Home',
      name: 'home',
      component: () => import('./../views/home-view/Home'),
      meta: {
        title: '首页',
      },
    },
    {
      path: '/about',
      name: 'about',
      component: () => import('./../views/About.vue'),
      meta: {
        title: '关于',
      },
    },
    {
      path: '/monthly-list',
      name: 'monthly-list',
      component: () => import('../views/monthly-summary/monthly-list.vue'),
      meta: {
        title: '月度汇总',
        requireAuth: true,
      },
    },
    {
      path: '/list-personal',
      name: 'list-personal',
      component: () => import('../components/list-personal.vue'),
      meta: {
        title: '月度汇总',
        requireAuth: true,
      },
    },
    {
      path: '/info-personal',
      name: 'info-personal',
      component: () => import('../views/monthly-summary/info-personal.vue'),
      meta: {
        title: '月度汇总',
        requireAuth: true,
      },
    },
    {
      path: '/edit-problem',
      name: 'edit-problem',
      component: () => import('../views/monthly-summary/edit-problem.vue'),
      meta: {
        title: '问题反馈',
        requireAuth: true,
      },
    },
    {
      path: '/new-resume',
      name: 'new-resume',
      component: () => import('../views/resume/new.vue'),
      meta: {
        title: '简历投递',
        requireAuth: false,
      },
    },
    {
      path: '/prove',
      name: 'prove',
      component: () => import('../views/prove-view/prove.vue'),
      meta: {
        title: '人脸采集',
        requireAuth: true,
        externalSSystem: true,
      },
    },
    {
      path: '/uWork-prove',
      name: 'uWork-prove',
      component: () => import('../views/prove-view/uWork-prove.vue'),
      meta: {
        title: '信息采集',
        requireAuth: false,
        externalSSystem: true,
      },
    },
    {
      path: '/uWork-Ops-prove',
      name: 'uWork-Ops-prove',
      component: () => import('../views/prove-view/uWork-Ops-prove.vue'),
      meta: {
        title: '信息采集',
        requireAuth: false,
        externalSSystem: true,
      },
    },
    {
      path: '/invitation',
      name: 'Invitation',
      component: () => import('../views/extend/invitation.vue'),
      meta: {
        title: '中瑞集团8周年庆典',
        requireAuth: true,
      },
    },
    {
      path: '/entry',
      name: 'entry',
      component: () => import('../views/entry/entry.vue'),
      meta: {
        title: '入职编辑',
        requireAuth: true,
      },
    },
    {
      path: '/recharge',
      name: 'recharge',
      component: () => import('../views/recharge/Recharge.vue'),
      meta: {
        title: '充值',
        requireAuth: true,
      },
    },
    {
      path: '/recharge-list',
      name: 'recharge-list',
      component: () => import('../views/recharge/RechargeList.vue'),
      meta: {
        title: '充值',
        requireAuth: true,
      },
    },
    {
      path: '/recharge-details',
      name: 'recharge-details',
      component: () => import('../views/recharge/RechargeDetails.vue'),
      meta: {
        title: '充值详情',
        requireAuth: true,
      },
    },
    {
      path: '/spend-details',
      name: 'spend-details',
      component: () => import('../views/recharge/SpendDetails.vue'),
      meta: {
        title: '消费明细',
        requireAuth: true,
      },
    },
    {
      path: '/pay-success',
      name: 'pay-success',
      component: () => import('../views/recharge/Success.vue'),
      meta: {
        title: '付款',
        requireAuth: true,
      },
    },
    {
      path: '/pay',
      name: 'pay',
      component: () => import('../views/recharge/Pay.vue'),
      meta: {
        title: '付款',
        requireAuth: true,
      },
    },
    {
      path: '/tripinfo-list',
      name: 'tripinfo-list',
      component: () => import('../views/TripInfo/TripInfoList.vue'),
      meta: {
        title: '出行信息',
        requireAuth: true,
      },
    },
    {
      path: '/tripinfo-new',
      name: 'tripinfo-new',
      component: () => import('../views/TripInfo/TripInfoNew.vue'),
      meta: {
        title: '订票',
        requireAuth: true,
      },
    },
    {
      path: '/tripinfo-edit',
      name: 'tripinfo-edit',
      component: () => import('../views/TripInfo/TripInfoNew.vue'),
      meta: {
        title: '编辑行程',
        requireAuth: true,
      },
    },
    {
      path: '/tripinfo-show',
      name: 'tripinfo-show',
      component: () => import('../views/TripInfo/TripInfoShow.vue'),
      meta: {
        title: '出行信息',
        requireAuth: true,
      },
    },
    {
      path: '/tripinfo-audit',
      name: 'tripinfo-audit',
      component: () => import('../views/TripInfo/TripInfoAudit.vue'),
      meta: {
        title: '行程审批',
        requireAuth: true,
      },
    },
    {
      path: '/airticket-booking',
      name: 'airticket-booking',
      component: () => import('../views/TripInfo/AirTicketBooking.vue'),
      meta: {
        title: '订票',
        requireAuth: true,
      },
    },
    {
      path: '/airticket-choose',
      name: 'airticket-choose',
      component: () => import('../views/TripInfo/AirTicketChoose.vue'),
      meta: {
        title: '订票',
        requireAuth: true,
      },
    },
    {
      path: '/airticket-help',
      name: 'airticket-help',
      component: () => import('../views/TripInfo/AirTicketHelp.vue'),
      meta: {
        title: '帮订',
        requireAuth: true,
      },
    },
    {
      path: '/airticket-submit',
      name: 'airticket-submit',
      component: () => import('../views/TripInfo/AirTicketSubmit.vue'),
      meta: {
        title: '提交',
        requireAuth: true,
      },
    },
    {
      path: '/airticket-success',
      name: 'airticket-success',
      component: () => import('../views/TripInfo/AirTicketResult.vue'),
      meta: {
        title: '提交',
        requireAuth: true,
      },
    },
    {
      path: '/airticket-wait',
      name: 'airticket-wait',
      component: () => import('../views/TripInfo/AirTicketResult.vue'),
      meta: {
        title: '提交',
        requireAuth: true,
      },
    },
    {
      path: '/airticket-error',
      name: 'airticket-error',
      component: () => import('../views/TripInfo/AirTicketResult.vue'),
      meta: {
        title: '提交',
        requireAuth: true,
      },
    },
    {
      path: '/airticket-auditSuccess',
      name: 'airticket-auditSuccess',
      component: () => import('../views/TripInfo/AirTicketResult.vue'),
      meta: {
        title: '退票',
        requireAuth: true,
      },
    },
    {
      path: '/airticket-refund',
      name: 'airticket-refund',
      component: () => import('../views/TripInfo/AirTicketRefund.vue'),
      meta: {
        title: '退票',
        requireAuth: true,
      },
    },
    {
      path: '/audit-reason',
      name: 'audit-reason',
      component: () => import('../views/TripInfo/AuditReason.vue'),
      meta: {
        title: '退票/改签',
        requireAuth: true,
      },
    },
    {
      path: '/audit-airTicket',
      name: 'audit-airTicket',
      component: () => import('../views/TripInfo/AuditAirTicket.vue'),
      meta: {
        title: '机票审批',
        requireAuth: true,
      },
    },
    {
      path: '/myaddress',
      name: 'TestMap',
      component: () => import('../views/test/testMap.vue'),
      meta: {
        title: '我的位置',
        requireAuth: false,
      },
    },
  ],
});

import { Dialog } from 'vant';
import cookie from '@/assets/js/cookie/cookie';

// 判定使用的变量
let WECHAT_CORPID: string;
let MONTHSUMMARY_APPID: string;
let WECHAT_BINDURL: string;
let ToRouter: string;
let LOCAL_HOSTNAME: string;
declare const WeixinJSBridge: any;
if (location.hostname === config.LOCALHOST_LOCAL || location.hostname === config.LOCALHOST_DEV || location.hostname === config.LOCALHOST_FAT) {
  WECHAT_CORPID = config.WECHAT_CORPID_DEV;
  MONTHSUMMARY_APPID = config.MONTHSUMMARY_APPID_DEV;
  WECHAT_BINDURL = config.WECHAT_BINDURL_DEV;
  ToRouter = 'http://ehr-wechat-vue.efckudu.lunztech.cn/#';
  LOCAL_HOSTNAME = config.LOCALHOST_FAT;
} else if (location.hostname === config.LOCALHOST_LIVE || location.hostname === config.LOCALHOST_PROD || location.hostname === config.LOCALHOST_PROD_OLD) {
  WECHAT_CORPID = config.WECHAT_CORPID_PROD;
  MONTHSUMMARY_APPID = config.MONTHSUMMARY_APPID_PROD;
  WECHAT_BINDURL = config.WECHAT_BINDURL_PROD;
  ToRouter = 'http://ehr-wechat-vue.lunz.cn/#';
  LOCAL_HOSTNAME = config.LOCALHOST_PROD;
}

function clearCookie() {
  cookie.del('EXPDATE');
  cookie.del('AUTHTOKEN');
  cookie.del('CURLOGINNAME');
  wxRedireURL();
}

function errorClose(errorMsg: any) {
  Dialog.alert({
    title: '错误',
    message: errorMsg,
  }).then(() => {
    closePage();
  });
}

function closePage() {
  const userAgent = navigator.userAgent;
  // Firefox或Chrome中关闭
  if (userAgent.indexOf('Firefox') !== -1 || userAgent.indexOf('Chrome') !== -1) {
    window.location.href = 'about:blank';
  } else {
    window.opener = null;
    window.open('', '_self');
    window.close();
  }
  // 微信中关闭
  if (WeixinJSBridge) {
    WeixinJSBridge.call('closeWindow');
  }
}

function wxRedireURL(url?: string) {
  const originalURL = url ? url : window.location.href;
  const urlObj = new URL(originalURL);
  // 将域名替换为 LOCAL_HOSTNAME(按环境区分）)
  urlObj.hostname = LOCAL_HOSTNAME;
  const encodeURL = encodeURI(urlObj.toString());
  window.location.replace('https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + WECHAT_CORPID + '&redirect_uri=' + encodeURL + '&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect');
}

// 全局前置守卫
router.beforeEach((to: any, from, next) => {
  
  // 如果未匹配到路由
  if (to.matched.length === 0) {
    // 如果上级也未匹配到路由则跳转登录页面，如果上级能匹配到则转上级路由
    from.name ? next({ name: from.name }) : next('/');
  } else {

    // // 本地运行打开
    // if (to.meta.title) {
    //   document.title = to.meta.title;
    // }
    // next();
    // return;

    // 人脸采集(外部系统验证)
    if (to.meta.externalSSystem) {
      document.title = to.meta.title;
      if (to.query.from === '' || to.query.from === undefined || to.query.from === null) {
        next();
        return;
      }
    }

    // 如果不需要身份验证
    if (!to.meta.requireAuth) {
      document.title = to.meta.title;
      //  如果参数中存在wechatlogin，认为是微信的回调
      const query = new URLSearchParams(location.search);
      if (query.get('wechatlogin')) {
        // 跳转到参数中指定的路由
        const targetPage = query.get('wechatlogin');
        query.delete('wechatlogin');
        window.location.replace(window.location.origin + '/#/' + targetPage + '?' + query.toString());
      } else {
        next();
      }
      return;
    }

    


    /**
     * 检查是否已有身份信息
     * 检查是否超出过期时间
     */
    if (cookie.check('EXPDATE')) {
      const expDate = cookie.get('EXPDATE');
      const dateNow = new Date();
      if (dateNow.getTime().toString() < expDate.toString()) {
        if (to.meta.title) {
          document.title = to.meta.title;
          cookie.set('PATH_ROUTE', to.path, 2);
        }
        // 刷新缓存
        if (JSON.stringify(to.query) !== '{}') {
          window.localStorage.setItem('THIS_LOCATION_HREF_QUERY', JSON.stringify(to.query));
        }
        next();
        return;
      }
    }

    // 取code
    const locationHref = new URL(window.location.href);
    const params = new URLSearchParams(locationHref.search);
    const codeStr  = params.get('code');

    // window.alert(codeStr);
    
    if (!codeStr) {
      if (JSON.stringify(to.query) !== '{}') {
        window.localStorage.setItem('THIS_LOCATION_HREF_QUERY', JSON.stringify(to.query));
      }
      cookie.set('PATH_ROUTE', to.path, 2);
      wxRedireURL(window.location.href);
    } else {
      // 截取code并赋值
      // const codeStr = window.location.href.split('#')[0].split('code=')[1];
      // 调用接口获取accessToken
      const param = {
        sCorpID: WECHAT_CORPID,
        appId: MONTHSUMMARY_APPID,
      };
      api.handleGetToken('WeChatInterface/WeChatInterface/GetAccessToken', param, (result: any) => {
        if (result.Success && result.Data) {
          // 获取code
          const params = {
            accessToken: result.Data,
            code: codeStr,
          };
          api.handleGetToken('WeChatInterface/WeChatInterface/GetCode', params, (response: any) => {
            // 企业成员
            // response.Data && response.Data.errcode === '0' && response.Data.UserId
            if (response.Success && response.Data && response.Data.errcode === '0' && response.Data.UserId) {
              // 验证是否已经绑定，如果绑定则模拟登录获取AUTHTOKEN，否则绑定
              const bindCode = {
                code: response.Data.UserId,
              };
              api.handleGetToken('WeChatInterface/WeChatInterface/IsBindByCode', bindCode, (isbind: any) => {
                if (isbind.Success && isbind.Data === true) {
                  // 获取SecretKey
                  api.handleGetToken('WeChatInterface/WeChatInterface/GetSecretKey', null, (getSecretKey: any) => {
                    if (getSecretKey.Success && getSecretKey.Data) {
                      // 根据SecretKey对工号进行AES加密
                      const encryptCodeStr = AES.encrypt(response.Data.UserId, getSecretKey.Data);
                      // 使用加密后的Code获取AUTHTOKEN
                      const encryptCode = {
                        code: encryptCodeStr,
                      };
                      api.handleGetToken('membership/Monthlysummary/GetAuthTokenByCode', encryptCode, (getAuthToken: any) => {
                        if (getAuthToken.Success && getAuthToken.Data) {
                          // 将AUTHTOKEN存到cookie中，两小时
                          const expDate = new Date();
                          expDate.setTime(expDate.getTime() + 2 * 60 * 60 * 1000);
                          cookie.set('EXPDATE', expDate.getTime(), 2);
                          cookie.set('AUTHTOKEN', getAuthToken.Data, 2);
                          cookie.set('CURLOGINNAME', bindCode.code, 2);
                          // 路由发生变化修改页面title
                          //   let search = '';
                          //   const params = JSON.parse(window.localStorage.getItem('THIS_LOCATION_HREF_QUERY') || '');
                          //   if (params !== '') {
                          //     // 拼接参数
                          //     search = '?';
                          //     for (let k in params) {
                          //       search = search + k + '=' + params[k] + '&';
                          //     }
                          //     search = search.substr(0, search.length - 1);
                          //   }
                          // window.location.replace(window.location.origin + '/#' + cookie.get('PATH_ROUTE')) + search;
                          window.location.replace(window.location.origin + '/#' + cookie.get('PATH_ROUTE'));
                        } else {
                          // 登录绑定
                          next({
                            path: '/',
                            query: { redirect: to.fullPath },
                          });
                        }
                      }, (error: any) => {
                        errorClose(error);
                      });
                    }
                  }, (error: any) => {
                    errorClose(error);
                  });
                } else {
                  cookie.del('EXPDATE');
                  cookie.del('AUTHTOKEN');
                  cookie.del('CURLOGINNAME');
                  window.location.replace(WECHAT_BINDURL + encodeURIComponent(window.location.origin + '/#' + cookie.get('PATH_ROUTE')));
                }
              }, (error: any) => {
                errorClose(error);
              });
            } else {
              clearCookie();
            }
          }, (error: any) => {
            errorClose(error);
          });
        } else {
          clearCookie();
        }
      }, (error: any) => {
        errorClose(error);
      });
    }
  }
});

export default router;

// // 判定使用的变量
// let WECHAT_CORPID: string;
// let MONTHSUMMARY_APPID: string;
// let WECHAT_BINDURL: string;
// let ToRouter: string;
// const RouterName: string = '/monthly-list';
// if (location.hostname === config.LOCALHOST_LOCAL || location.hostname === config.LOCALHOST_DEV) {
//   WECHAT_CORPID = config.WECHAT_CORPID_DEV;
//   MONTHSUMMARY_APPID = config.MONTHSUMMARY_APPID_DEV;
//   WECHAT_BINDURL = config.WECHAT_BINDURL_DEV;
//   ToRouter = 'http://ehr-wechat-vue.efckudu.lunztech.cn/#';
// } else if (location.hostname === config.LOCALHOST_LIVE || location.hostname === config.LOCALHOST_PROD) {
//   WECHAT_CORPID = config.WECHAT_CORPID_PROD;
//   MONTHSUMMARY_APPID = config.MONTHSUMMARY_APPID_PROD;
//   WECHAT_BINDURL = config.WECHAT_BINDURL_PROD;
//   ToRouter = 'http://ehr-wechat-vue.lunz.cn/#';
// }

// function clearCookie() {
//   cookie.del('EXPDATE');
//   cookie.del('AUTHTOKEN');
//   cookie.del('CURLOGINNAME');
//   window.location.href = WECHAT_BINDURL + ToRouter + RouterName;
// }

// // 全局前置守卫
// router.beforeEach((to: any, from, next) => {
//   // 如果未匹配到路由
//   if (to.matched.length === 0) {
//     // 如果上级也未匹配到路由则跳转登录页面，如果上级能匹配到则转上级路由
//     from.name ? next({ name: from.name }) : next('/');
//   } else {
//     // if (to.meta.title) {
//     //   document.title = to.meta.title;
//     // }
//     // next();
//     // return;
//     // 入职编辑
//     if (to.meta.entryEdit) {
//       document.title = to.meta.title;
//       cookie.set('PATH_ROUTE', to.path, 2);
//     }
//     // 8周年
//     if (to.meta.isAnniversary) {
//       document.title = to.meta.title;
//       if (to.query.address) {
//         window.localStorage.setItem('INVITAION_ADDRESS', to.query.address);
//       }
//       cookie.set('PATH_ROUTE', to.path, 2);
//     }
//     // 人脸采集
//     if (to.meta.identityProve) {
//       document.title = to.meta.title;
//       if (to.query.from === '' || to.query.from === undefined || to.query.from === null) {
//         next();
//         return;
//       }
//     }
//     // 简历投递
//     if (to.meta.resumeAdd) {
//       document.title = to.meta.title;
//       next();
//       return;
//     }
//     if (!to.meta.requireAuth && !to.meta.identityProve && !to.meta.isAnniversary && !to.meta.entryEdit) {
//       window.location.replace(ToRouter + RouterName);
//     }
//     // 检查是否超出过期时间
//     if (cookie.check('EXPDATE')) {
//       const expDate = cookie.get('EXPDATE');
//       const dateNow = new Date();
//       if (dateNow.getTime().toString() < expDate.toString()) {
//         if (to.meta.title) {
//           document.title = to.meta.title;
//         }
//         next();
//         return;
//       }
//     }
//     if (window.location.href.indexOf('code') === -1) {
//       window.location.replace('https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + WECHAT_CORPID + '&redirect_uri=' + encodeURI(window.location.href) + '&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect');
//     } else {
//       // 截取code并赋值
//       if (to.query.code === '' || to.query.code === undefined || to.query.code === null) {
//         const codeStr = window.location.href.split('#')[0].split('code=')[1];
//         to.query.code = codeStr;
//       }
//       // 调用接口获取accessToken
//       const param = {
//         sCorpID: WECHAT_CORPID,
//         appId: MONTHSUMMARY_APPID,
//       };
//       api.handleGetToken('WeChatInterface/WeChatInterface/GetAccessToken', param, (result: any) => {
//         if (result.Success) {
//           // 获取code
//           const params = {
//             accessToken: result.Data,
//             code: to.query.code,
//           };
//           api.handleGetToken('WeChatInterface/WeChatInterface/GetCode', params, (response: any) => {
//             if (response.Success) {
//               // 企业成员
//               // response.Data && response.Data.errcode === '0' && response.Data.UserId
//               if (response.Data && response.Data.errcode === '0' && response.Data.UserId) {
//                 // 验证是否已经绑定，如果绑定则模拟登录获取AUTHTOKEN，否则绑定
//                 const bindCode = {
//                   code: response.Data.UserId,
//                 };
//                 api.handleGetToken('WeChatInterface/WeChatInterface/IsBindByCode', bindCode, (isbind: any) => {
//                   if (isbind.Success) {
//                     if (isbind.Data === true) {
//                       // 获取AUTHTOKEN
//                       api.handleGetToken('membership/Monthlysummary/GetAuthTokenByCode', bindCode, (getAuthToken: any) => {
//                         if (getAuthToken.Success) {
//                           if (getAuthToken.Data) {
//                             // 将AUTHTOKEN存到cookie中，两小时
//                             const expDate = new Date();
//                             expDate.setTime(expDate.getTime() + 2 * 60 * 60 * 1000);
//                             cookie.set('EXPDATE', expDate.getTime(), 2);
//                             cookie.set('AUTHTOKEN', getAuthToken.Data, 2);
//                             cookie.set('CURLOGINNAME', bindCode.code, 2);
//                             // 路由发生变化修改页面title
//                             if (to.meta.identityProve) {
//                               window.location.replace(ToRouter + '/prove');
//                             } else {
//                               if (cookie.check('PATH_ROUTE')) {
//                                 window.location.replace(ToRouter + cookie.get('PATH_ROUTE'));
//                               } else {
//                                 window.location.replace(ToRouter + RouterName);
//                               }
//                             }
//                           }
//                         } else {
//                           // 登录绑定
//                           next({
//                             path: '/',
//                             query: { redirect: to.fullPath },
//                           });
//                         }
//                       }, (error: any) => {
//                         Dialog.alert({
//                           title: '错误',
//                           message: error,
//                         });
//                       });
//                     } else {
//                       clearCookie();
//                     }
//                   } else {
//                     clearCookie();
//                   }
//                 }, (error: any) => {
//                   Dialog.alert({
//                     title: '错误',
//                     message: error,
//                   });
//                 });
//               } else {
//                 clearCookie();
//               }
//               // return;
//             } else {
//               clearCookie();
//             }
//           }, (error: any) => {
//             Dialog.alert({
//               title: '错误',
//               message: error,
//             });
//           });
//         } else {
//           clearCookie();
//         }
//       }, (error: any) => {
//         Dialog.alert({
//           title: '错误',
//           message: error,
//         });
//       });
//     }
//   }
// });

// export default router;
